import { BaseEntityDto } from "@/core/common/entities/base-entity.dto";
import { EmployeeDocumentCategoryTemplateVersionDto } from "@/core/features/employee-document-categories/employee-document-category-template-version.dto";
import { Type } from "class-transformer";

export class EmployeeDocumentCategoryTemplateDto extends BaseEntityDto {
  categoryId: string;
  isActive: boolean;

  @Type(() => EmployeeDocumentCategoryTemplateVersionDto)
  versions?: EmployeeDocumentCategoryTemplateVersionDto[];

  get latestVersion(): EmployeeDocumentCategoryTemplateVersionDto | null {
    if (!this.versions?.length) {
      return null;
    }

    return [...this.versions].sort((left, right) => right.versionNumber - left.versionNumber)[0];
  }
}
